import React, { Component } from 'react';

import './Engajamento.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import Parallax from 'parallax-js';
import { Line, Doughnut, Pie } from 'react-chartjs-2';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import Swipeable from 'react-swipeable';
import OwlCarousel from 'react-owl-carousel2';
import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	isEdge
} from '../../utils';

import {
	images,
	views
} from '../../settings';

import {
	Person,
	HoveredImage,
	Compromisso
} from '../../components/';

class Engajamento extends Component {

	constructor() {
		super();

        this.images = images;

        this.colorSuperintendentes = (isEdge) ? '29,147,209' :  '#1D93D1';
        this.colorGerentes = (isEdge) ? '65,185,195' :  '#41B9C3';
        this.colorCoordenadores = (isEdge) ? '209,219,53' :  '#D1DB35';
        this.colorAnalistas = (isEdge) ? '127,195,67' :  '#7FC343';
        this.colorAssistentes = (isEdge) ? '248,219,86' :  '#F8DB56';
        this.colorApoios = (isEdge) ? '250,174,27' :  '#FAAE1B';
        this.colorEstagiarios = (isEdge) ? '38,68,120' :  '#264478';
        this.colorJovensAprendizes = (isEdge) ? '78,78,80' :  '#4E4E50';

        let colorSuperintendentes = (isEdge) ? 'rgba('+this.colorSuperintendentes+',1)' : this.colorSuperintendentes,
			colorGerentes = (isEdge) ? 'rgba('+this.colorGerentes+',1)' : this.colorGerentes,
			colorCoordenadores = (isEdge) ? 'rgba('+this.colorCoordenadores+',1)' : this.colorCoordenadores,
			colorAnalistas = (isEdge) ? 'rgba('+this.colorAnalistas+',1)' : this.colorAnalistas,
			colorAssistentes = (isEdge) ? 'rgba('+this.colorAssistentes+',1)' : this.colorAssistentes,
			colorApoios = (isEdge) ? 'rgba('+this.colorApoios+',1)' : this.colorApoios,
			colorEstagiarios = (isEdge) ? 'rgba('+this.colorEstagiarios+',1)' : this.colorEstagiarios,
			colorJovensAprendizes = (isEdge) ? 'rgba('+this.colorJovensAprendizes+',1)' : this.colorJovensAprendizes;

        this.state = {
            borderWidth: 0,

			colorSuperintendentes: colorSuperintendentes,
			colorGerentes: colorGerentes,
			colorCoordenadores: colorCoordenadores,
			colorAnalistas: colorAnalistas,
			colorAssistentes: colorAssistentes,
			colorApoios: colorApoios,
			colorEstagiarios: colorEstagiarios,
			colorJovensAprendizes: colorJovensAprendizes,

            width: window.innerWidth
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	    this.changeChartColor = this.changeChartColor.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('5.4 Engajamento');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
    }


    changeChartColor(area) {
    	let opacity = (isEdge) ? ',.2' : '15';

    	let colorSuperintendentes = (isEdge) ? 'rgba('+this.colorSuperintendentes+opacity+')' :  this.colorSuperintendentes + opacity;
    	let colorGerentes = (isEdge) ? 'rgba('+this.colorGerentes+opacity+')' :  this.colorGerentes + opacity;
    	let colorCoordenadores = (isEdge) ? 'rgba('+this.colorCoordenadores+opacity+')' :  this.colorCoordenadores + opacity;
    	let colorAnalistas = (isEdge) ? 'rgba('+this.colorAnalistas+opacity+')' :  this.colorAnalistas + opacity;
    	let colorAssistentes = (isEdge) ? 'rgba('+this.colorAssistentes+opacity+')' :  this.colorAssistentes + opacity;
    	let colorApoios = (isEdge) ? 'rgba('+this.colorApoios+opacity+')' :  this.colorApoios + opacity;
    	let colorEstagiarios = (isEdge) ? 'rgba('+this.colorEstagiarios+opacity+')' :  this.colorEstagiarios + opacity;
    	let colorJovensAprendizes = (isEdge) ? 'rgba('+this.colorJovensAprendizes+opacity+')' :  this.colorJovensAprendizes + opacity;

    	switch (area) {
    		case "superintendentes":
    			// colorSuperintendentes = this.colorSuperintendentes;
    			colorSuperintendentes = (isEdge) ? 'rgba('+this.colorSuperintendentes+',1)' : this.colorSuperintendentes;
    			break;

    		case "gerentes":
    			// colorGerentes = this.colorGerentes;
    			colorGerentes = (isEdge) ? 'rgba('+this.colorGerentes+',1)' : this.colorGerentes;
    			break;

    		case "coordenadores":
    			colorCoordenadores = (isEdge) ? 'rgba('+this.colorCoordenadores+',1)' : this.colorCoordenadores;
    			// colorCoordenadores = this.colorCoordenadores;
    			break;

    		case "analistas":
    			colorAnalistas = (isEdge) ? 'rgba('+this.colorAnalistas+',1)' : this.colorAnalistas;
    			// colorAnalistas = this.colorAnalistas;
    			break;

    		case "assistentes":
    			colorAssistentes = (isEdge) ? 'rgba('+this.colorAssistentes+',1)' : this.colorAssistentes;
    			// colorAssistentes = this.colorAssistentes;
    			break;

    		case "apoios":
    			colorApoios = (isEdge) ? 'rgba('+this.colorApoios+',1)' : this.colorApoios;
    			// colorApoios = this.colorApoios;
    			break;

    		case "estagiarios":
    			colorEstagiarios = (isEdge) ? 'rgba('+this.colorEstagiarios+',1)' : this.colorEstagiarios;
    			// colorEstagiarios = this.colorEstagiarios;
    			break;

    		case "jovens-aprendizes":
    			colorJovensAprendizes = (isEdge) ? 'rgba('+this.colorJovensAprendizes+',1)' : this.colorJovensAprendizes;
    			// colorJovensAprendizes = this.colorJovensAprendizes;
    			break;

    		default:
    			colorSuperintendentes = (isEdge) ? 'rgba('+this.colorSuperintendentes+',1)' : this.colorSuperintendentes;
    			// colorSuperintendentes = this.colorSuperintendentes;
    			colorGerentes = (isEdge) ? 'rgba('+this.colorGerentes+',1)' : this.colorGerentes;
    			// colorGerentes = this.colorGerentes;
    			colorCoordenadores = (isEdge) ? 'rgba('+this.colorCoordenadores+',1)' : this.colorCoordenadores;
    			// colorCoordenadores = this.colorCoordenadores;
    			colorAnalistas = (isEdge) ? 'rgba('+this.colorAnalistas+',1)' : this.colorAnalistas;
    			// colorAnalistas = this.colorAnalistas;
    			colorAssistentes = (isEdge) ? 'rgba('+this.colorAssistentes+',1)' : this.colorAssistentes;
    			// colorAssistentes = this.colorAssistentes;
    			colorApoios = (isEdge) ? 'rgba('+this.colorApoios+',1)' : this.colorApoios;
    			// colorApoios = this.colorApoios;
    			colorEstagiarios = (isEdge) ? 'rgba('+this.colorEstagiarios+',1)' : this.colorEstagiarios;
    			// colorEstagiarios = this.colorEstagiarios;
    			colorJovensAprendizes = (isEdge) ? 'rgba('+this.colorJovensAprendizes+',1)' : this.colorJovensAprendizes;
    			// colorJovensAprendizes = this.colorJovensAprendizes;
    			break;
    	}

		this.setState({
            colorSuperintendentes: colorSuperintendentes,
            colorGerentes: colorGerentes,
            colorCoordenadores: colorCoordenadores,
            colorAnalistas: colorAnalistas,
            colorAssistentes: colorAssistentes,
            colorApoios: colorApoios,
            colorEstagiarios: colorEstagiarios,
            colorJovensAprendizes: colorJovensAprendizes
		});
    }


	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'engajamento'
		];

		// const backgroundColor = [
		// 	// this.state.colorSuperintendentes,
  //   		(isEdge) ? 'rgba('+this.colorSuperintendentes+',1)' : this.colorSuperintendentes,

		// 	// this.state.colorGerentes,
  //   		(isEdge) ? 'rgba('+this.colorGerentes+',1)' : this.colorGerentes,
    		
		// 	// this.state.colorCoordenadores,
  //   		(isEdge) ? 'rgba('+this.colorCoordenadores+',1)' : this.colorCoordenadores,
    		
		// 	// this.state.colorAnalistas,
  //   		(isEdge) ? 'rgba('+this.colorAnalistas+',1)' : this.colorAnalistas,
    		
		// 	// this.state.colorAssistentes,
  //   		(isEdge) ? 'rgba('+this.colorAssistentes+',1)' : this.colorAssistentes,
    		
		// 	// this.state.colorApoios,
  //   		(isEdge) ? 'rgba('+this.colorApoios+',1)' : this.colorApoios,
    		
		// 	// this.state.colorEstagiarios,
  //   		(isEdge) ? 'rgba('+this.colorEstagiarios+',1)' : this.colorEstagiarios,
    		
		// 	// this.state.colorJovensAprendizes,
  //   		(isEdge) ? 'rgba('+this.colorJovensAprendizes+',1)' : this.colorJovensAprendizes,
		// ];

		const backgroundColor = [
			this.state.colorSuperintendentes,
			this.state.colorGerentes,
			this.state.colorCoordenadores,
			this.state.colorAnalistas,
			this.state.colorAssistentes,
			this.state.colorApoios,
			this.state.colorEstagiarios,
			this.state.colorJovensAprendizes,
		];

		const labels = [
			'Superintendentes',
			'Gerentes',
			'Coordenadores',
			'Analistas',
			'Assistentes',
			'Apoios',
			'Estagiários',
			'Jovens aprendizes'
		];

		const dataChart1 = {
			labels: labels,
			datasets: [{
				data: [
					124	,
					26.5,
					26,
					13.6,
					19.5,
					8.8,
					5,
					0
				],
				backgroundColor: backgroundColor,
				hoverBackgroundColor: backgroundColor,
				borderWidth: this.state.borderWidth
			}]
		};

		const dataChart2 = {
			labels: labels,
			datasets: [{
				data: [
					49.3,
					107.6,
					33.4,
					17.8,
					16.9,
					13.2,
					5.3,
					8
				],
				backgroundColor: backgroundColor,
				hoverBackgroundColor: backgroundColor,
				borderWidth: this.state.borderWidth
			}]
		};

		const legendOpts = {
			display: false
		};

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>5.4 Engajamento - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>5.4</span> Engajamento</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Pessoas</p>
		        			</div>
		        		</header>

		        		<div className="views__content first_view row">
			        		<div className="container">
			        			
				        		<div className="column column--half column--padding-right">
				        			<Fade bottom>
										<p className="gri_p">
					        				<span className="gri_label"><text>GRI 103-1, 103-2, 103-3</text></span>
										</p>
					        			<p className="first_paragraph">
						        			Investimos em capacitação e reconhecimento para obter os melhores resultados em atração e retenção de pessoas. Em 2018, integramos um estudo do anuário Valor Carreira, realizado pela consultoria de recursos humanos internacional Mercer em parceria com o jornal Valor Econômico. As notas máximas na avaliação que medem engajamento e prosperidade das empresas pela opinião dos funcionários foi de 88% e 76%, respectivamente.
						        			<br /><br />
											Como associação, a ANBIMA não está habilitada a integrar o ranking das 35 melhores – exclusivo para organizações que operam visando lucro, mas a participação de 253 colaboradores que responderam o questionário garantiu o ótimo resultado.
											<br />
										</p>
				        			</Fade>
				        		</div>

				        		<div className="column column--half column--image-full column--image-full-center">
				        			<Fade bottom>
				        				<img className="image_first" src={ this.images.engajamento_img1 } /> 
				        			</Fade>
				        		</div>

			        		</div> 
		        		</div>


		        		<div className="views__content views__content--section row engajamento__view engajamento__view--topics view__gray"> 
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<h3>ANBIMA No Ar</h3>
					        			<p>Programa de inovação lançado em junho de 2018 para inspirar os funcionários a buscaram diferenciação profissional e transformações corporativas. Conta com palestras motivacionais que abrangem desde segurança de informação até identificação de valores e ética. O projeto utiliza a intranet e um grupo do WhatsApp para divulgar informações. Deverá ser concluído no segundo semestre de 2019.</p>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section row last__view view__gray">
			        		<div className="container">
				        		<div className="column column--image-full column--image-full-center">
				        			<Fade bottom>
				        				<img src={ this.images.engajamento_img2 } />
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section row engajamento__view engajamento__view--last view__gray"> 
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<h3>Mentoring de gestores </h3>
					        			<p>O programa de desenvolvimento das lideranças internas começou em agosto. Dois profissionais especializados realizam treinamento com um grupo de 12 gestores, escolhidos de acordo com suas melhores qualidades. Esses, por sua vez, são mentores de outros dois gestores, escolhidos de acordo com as potencialidades que mais precisam desenvolver. Finalizado em fevereiro de 2019, o programa envolveu 36 gestores, entre superintendentes e gerentes. Em 2018, a educação corporativa não se limitou aos gestores e toda a equipe recebeu capacitação técnica e comportamental.</p>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section views__content--codigo-conduta-title row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
						        		<span className="gri_label visible_mobile"><text>GRI 404-1</text></span>
					        			<p className="section_subtitle">Número médio de horas de</p>
					        			<h2 className="section_title">
						        			treinamento<br />por colaborador<br />
						        			<span className="gri_label visible_desk"><text>GRI 404-1</text></span>
					        			</h2>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section views__content--colaboradores row">
			        		<div className="side side--left">
			        			<div className="word">Mulheres</div>
			        			<div className="chart">
			        				<Pie data={ dataChart1 } legend={ legendOpts } />
			        			</div>
			        			<img className="image" src={ this.images.engajamento_mulher } />
			        		</div>

			        		<div className="center">
				        		<div className="data_list">

					        		<div className="data_list__item data_list__item--superintendentes"
						                onMouseEnter={ this.changeChartColor.bind(null, 'superintendentes') }
						                onMouseLeave={ this.changeChartColor.bind(null, '') }>
						        		<div className="item__number">124h</div>
						        		<div className="item__text"><span>Superintendentes</span></div>
						        		<div className="item__number">49,3h</div>
					        		</div>

					        		<div className="data_list__item data_list__item--gerentes"
						                onMouseEnter={ this.changeChartColor.bind(null, 'gerentes') }
						                onMouseLeave={ this.changeChartColor.bind(null, '') }>
						        		<div className="item__number">26,5h</div>
						        		<div className="item__text"><span>Gerentes</span></div>
						        		<div className="item__number">107,6h</div>
					        		</div>

					        		<div className="data_list__item data_list__item--coordenadores"
						                onMouseEnter={ this.changeChartColor.bind(null, 'coordenadores') }
						                onMouseLeave={ this.changeChartColor.bind(null, '') }>
						        		<div className="item__number">26h</div>
						        		<div className="item__text"><span>Coordenadores</span></div>
						        		<div className="item__number">33,4h</div>
					        		</div>

					        		<div className="data_list__item data_list__item--analistas"
						                onMouseEnter={ this.changeChartColor.bind(null, 'analistas') }
						                onMouseLeave={ this.changeChartColor.bind(null, '') }>
						        		<div className="item__number">13,6h</div>
						        		<div className="item__text"><span>Analistas</span></div>
						        		<div className="item__number">17,8h</div>
					        		</div>

					        		<div className="data_list__item data_list__item--assistentes"
						                onMouseEnter={ this.changeChartColor.bind(null, 'assistentes') }
						                onMouseLeave={ this.changeChartColor.bind(null, '') }>
						        		<div className="item__number">19,5h</div>
						        		<div className="item__text"><span>Assistentes</span></div>
						        		<div className="item__number">16,9h</div>
					        		</div>

					        		<div className="data_list__item data_list__item--apoios"
						                onMouseEnter={ this.changeChartColor.bind(null, 'apoios') }
						                onMouseLeave={ this.changeChartColor.bind(null, '') }>
						        		<div className="item__number">8,8h</div>
						        		<div className="item__text"><span>Apoios</span></div>
						        		<div className="item__number">13,2h</div>
					        		</div>

					        		<div className="data_list__item data_list__item--estagiarios"
						                onMouseEnter={ this.changeChartColor.bind(null, 'estagiarios') }
						                onMouseLeave={ this.changeChartColor.bind(null, '') }>
						        		<div className="item__number">5h</div>
						        		<div className="item__text"><span>Estagiários</span></div>
						        		<div className="item__number">5,3h</div>
					        		</div>

					        		<div className="data_list__item data_list__item--jovens-aprendizes"
						                onMouseEnter={ this.changeChartColor.bind(null, 'jovens-aprendizes') }
						                onMouseLeave={ this.changeChartColor.bind(null, '') }>
						        		<div className="item__number">0h</div>
						        		<div className="item__text"><span>Jovens aprendizes</span></div>
						        		<div className="item__number">8h</div>
					        		</div>

				        		</div>
			        		</div>

			        		<div className="side side--right">
			        			<div className="word">Homens</div>
			        			<div className="chart">
			        				<Pie data={ dataChart2 } legend={ legendOpts } />
			        			</div>
			        			<img className="image" src={ this.images.engajamento_homem } />
			        		</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { Engajamento };
